export const ROUTES = {
    home: {
        path: "/",
        title: "Home",
    },
    blog: {
        path: "/blog",
        title: "Blog",
    },
    blogdetail: {
        path: "/blog/:slug",
        title: "Detail",
    },
    project: {
        path: "/projects",
        title: "Projects",
    },
    projectdetail: {
        path: "/projects/:slug",
        title: "Detail",
    },
    opleiding: {
        path: "/opleiding",
        title: "Opleiding",
    },
    services: {
        path: "/services",
        title: "services",
    },
    programma: {
        path: "/programma",
        title: "programma",
    },
    team: {
        path: "/team",
        title: "team",
    },
    search: {
        path: "/search/:slug",
        title: "Search",
    },
};
